<template>
  <svg width="10"
       height="22"
       viewBox="0 0 10 22"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M5 4.44922C6.16895 4.44922 7.10938 3.48242 7.10938 2.34863C7.10938 1.17969 6.16895 0.230469 5 0.230469C3.82227 0.230469 2.89941 1.17969 2.89941 2.34863C2.89941 3.5 3.82227 4.44922 5 4.44922ZM0.227539 13.4053C0.227539 14.0293 0.587891 14.3809 1.12402 14.3809C1.64258 14.3809 2.01172 14.0293 2.01172 13.4053V9.10742C2.01172 8.8877 2.13477 8.73828 2.31934 8.73828C2.50391 8.73828 2.62695 8.8877 2.62695 9.10742V20.1201C2.62695 20.8057 3.04883 21.1836 3.62891 21.1836C4.2002 21.1836 4.62207 20.8057 4.62207 20.1201V13.6426C4.62207 13.3613 4.77148 13.1943 5 13.1943C5.21973 13.1943 5.36914 13.3613 5.36914 13.6426V20.1201C5.36914 20.8057 5.7998 21.1836 6.37109 21.1836C6.94238 21.1836 7.36426 20.8057 7.36426 20.1201V9.10742C7.36426 8.8877 7.4873 8.73828 7.67188 8.73828C7.85645 8.73828 7.97949 8.8877 7.97949 9.10742V13.4053C7.97949 14.0293 8.34863 14.3809 8.87598 14.3809C9.40332 14.3809 9.76367 14.0293 9.76367 13.4053V9.03711C9.76367 6.6377 8.07617 5.32812 5 5.32812C1.91504 5.32812 0.227539 6.6377 0.227539 9.03711V13.4053Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'PrimaryIcon',
  props: {
    width: {
      type: Number,
      default: 7
    },
    height: {
      type: Number,
      default: 11
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
